import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  OnDestroy,
  Inject,
  DOCUMENT, inject, DestroyRef
} from '@angular/core';
import { Location } from '@angular/common';
import { Subject } from 'rxjs';
import { SettingsService } from '../../app-shared/services/settings.service';
import {  Router } from '@angular/router';
import { HeaderService } from 'src/app/app-shared/services/header.service';
import { SettingHeader } from 'src/app/app-shared/models/setting-header';
import { CartService } from 'src/app/app-shared/services/cart.service';
import { takeUntil } from 'rxjs';
import { CatalogService } from 'src/app/catalog/catalog.service';
import {
  SupplierPluginsNames,
  OrderType
} from 'src/app/app-shared/models/supplier-outlet.model';
import { SupplierOutletService } from '../../app-shared/services/supplier-outlet.service';
import {
  MainUserService,
  PermissionsService,
} from 'src/app/app-shared';
import { StorageService } from 'src/app/app-shared/services/storage.service';
import { PriorityListType } from '../../catalog/models/product.model';
import { SearchService } from '../../app-shared/services/search-service';
import { allUserPermissions } from '../../app-shared/models/user-phermissions.model';
import {ObjectForeSearch} from "../../catalog/models/search.model";
import {PromoService} from "../../promotions/promotions.service";
import {UserNotificationService} from "../user-notification/user-notification.service";
import {FadeInOutAnimation} from "../../app-shared/animations/fade-in-out-animation";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false,
    animations: [FadeInOutAnimation]
})
export class HeaderComponent implements OnInit {
  @Input() inputName;
  @Input() forbidBackLocation: boolean;
  @Input() disableMenuClick: boolean;
  @Input() disableChangeUser: boolean;
  @Output() changeHeader = new EventEmitter();
  @Output() addToCart = new EventEmitter();
  @Output() addNewCategory = new EventEmitter();
  @Output() openNotifications = new EventEmitter();
  totalCartSum = null;
  quantityProducts = 0;
  quantityTare = 0;

  isPageCart: boolean;
  isPageHome: boolean;
  isPageFilter: boolean;
  showArrowBack: boolean;
  showMenu: boolean;
  isCart = true;
  titlePage: string;
  hideHeader: boolean;
  hideSubHeader: boolean;

  showSwitcherLang: boolean;
  showTitle: boolean;

  public mobile: boolean;
  isPackingReturnOutletsAndSuppliers = false;

  allowActivateOutlet: boolean;
  readonly OrderTypes = OrderType;
  readonly priorityListType = PriorityListType;
  hideSearch: boolean = false;

  isHasPromo: boolean;
  private readonly destroyRef = inject(DestroyRef);

  constructor(
    public settings: SettingsService,
    private router: Router,
    private header: HeaderService,
    private location: Location,
    public cartService: CartService,
    private catalogService: CatalogService,
    private supplierOutletService: SupplierOutletService,
    private mainUserService: MainUserService,
    @Inject(DOCUMENT) private document: Document,
    private storageService: StorageService,
    public searchService: SearchService,
    public permissionsService: PermissionsService,
    private promoService: PromoService,
    public userNotificationService: UserNotificationService,
  ) {
    header.settingHeader
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((set: SettingHeader) => {
      this.isPageCart = /\/cart/.test(this.router.url);
      this.isPageHome = set.isPageHome;
      this.isPageFilter = set.isPageFilter;
      this.titlePage = set.title;
      this.showTitle = set.showTitle;
      this.showArrowBack = set.showArrowBack !== undefined ? set.showArrowBack : true;
      this.isCart = set.isCart;
      this.hideHeader = 'hideHeader' in set ? set.hideHeader : false;
      this.hideSubHeader = 'hideSubHeader' in set ? set.hideSubHeader : false;
      this.showMenu = 'showMenu' in set ? set.showMenu : true;
      this.showSwitcherLang =
        'showSwitcherLang' in set ? set.showSwitcherLang : true;
      this.forbidBackLocation = set.forbidBackLocation;
    });
    this.allowActivateOutlet =
      this.mainUserService.getUserData().allowActivateOutlet;
    this.header.hideSearch
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(hideSearch => {
        this.hideSearch = hideSearch;
      })
  }

  ngOnInit() {
    this.searchService.disabled = this.disableMenuClick;
    this.mobile = this.settings.isMobileSize();
    const cartDisplayMode = this.storageService.getFromLocalStorage('cartDisplayMode');
    this.cartService.productsInCartSubjectNewTotal
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data) => {
      if(data) {
        this.totalCartSum = data['commonTotal'] || 0;
        this.quantityProducts = cartDisplayMode == '0' ? data['quantity'] : data['totalQuantity'];
        this.quantityTare = data['totalTare'];
      }
    });
    this.checkIsTare();
    this.getPromotions();
  }


  getPromotions() {
    this.promoService.promoData
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((promo) => {
        this.isHasPromo = promo.length > 0;
      });
  }
  checkIsTare() {
    this.isPackingReturnOutletsAndSuppliers =
      this.supplierOutletService.isActivateSupplierSetting(
        SupplierPluginsNames.IsPackingReturn
      );
  }

  toCart() {
    if (this.disableMenuClick || (this.totalCartSum === null && !this.mobile)) return;
    if (
      !this.permissionsService.isAvailableForUser(
        allUserPermissions.isCreateOrder
      )
    ) {
      this.permissionsService.setUserPermissionError();
      return;
    }
    if (!this.isPageCart) {
      if (this.mobile) {
        this.router.navigate(['/cart']);
      } else {
        this.addToCart.emit(true);
      }
    }
  }

  toBack() {
    if (!this.forbidBackLocation) {
      this.location.back();
    }
    this.catalogService.updateMobileFilter.next();
    this.header.backClick.next();
  }
  addNewCategoryClick() {
    this.addNewCategory.emit();
  }

  openNotificationsClick() {
    this.openNotifications.emit(true);
  }

  searchInput(searchText) {
    const isTare = this.router.url.includes(
      this.OrderTypes[this.OrderTypes.tare]
    );
    const isCatalog = this.router.url.includes('/catalog');
    const navigateCatalog = isTare ? '/catalog/tare' : '/catalog';
    this.router.navigate([navigateCatalog]).then(() => {
      const searchModel = {
        objectForeSearch: ObjectForeSearch.IsProductName,
        values: [searchText],
      };
      sessionStorage.setItem('searchModel', JSON.stringify(searchModel));
      if (isCatalog) {
        this.catalogService.getProducts(false, {
          plTypes: isTare
            ? [this.priorityListType.tare]
            : [this.priorityListType.allLists],
          searchModel: searchModel,
          skip: 0,
        });
      }
    });
  }

  goToPromo(){
    this.router.navigate(['./promo'])
  }

  goToFilteredCatalogByPlType(plType: PriorityListType = PriorityListType.allLists) {
    this.clearSearch();
    const dataModel = [{ plType: plType}];
    sessionStorage.setItem('filterForPrice', JSON.stringify(dataModel));
    const searchModel = {
      objectForeSearch: ObjectForeSearch.IsProductName,
      values: [''],
    };
    if (this.router.url.includes('/catalog')) {
      this.catalogService.getProducts(false, {
        searchModel: searchModel,
        skip: 0,
      })
      this.router.navigate(['catalog'],  {
        queryParams: {promoId: null, outletId: null, supplierId: null, informationId: null},
        queryParamsHandling: 'merge'
      }).then(() => {
        this.scrollToStart();
      });
    } else {
      this.router.navigate(['/catalog']);
    }
   }

  clearSearch() {
    if (this.searchService.search) {
      this.searchService.search = '';
      this.searchService.disabled = false;
      this.searchService.lgSearchForDesktop = false;
    }
  }
  scrollToStart() {
    this.catalogService.loadingCatalogProductsSubject
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(res => {
        setTimeout(() => {
          const el = document.getElementById('main-catalog');
          el.scrollTop = 0;
        },  100)
      }).unsubscribe();
  }
}
